import { BASE_PATH } from '../utils/basePath';

export async function getLoanById(loanId: string) {
  const res = await fetch(`${BASE_PATH}/api/loans/${loanId}`, { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch loan details');
  return res.json();
}

export async function getLoanSchedule(loanId: string) {
  const res = await fetch(`${BASE_PATH}/api/loans/${loanId}/schedule`, { credentials: 'include' });
  if (!res.ok) throw new Error('Failed to fetch loan schedule');
  return res.json();
} 
